import type { InfoCard } from "../../types/content/infoCard";

const getInfoCardObject = ({ article }: { article: InfoCard }) => {
  return {
    id: `infoCard-${article.article_id}`,
    type: "UIElement",
    elementType: "InfoCard",
    name: article.teaser?.title?.value,
    "spt:custom": {
      is_sponsored: article.meta?.is_sponsored,
      sponsor: article.sponsor,
      vignette: article.story_vignette?.title,
      story: article.story?.title,
      category: article.category.title,
    },
  };
};

export { getInfoCardObject };
